import { render, staticRenderFns } from "./MemoryGame.vue?vue&type=template&id=3bca0c72&scoped=true&"
import script from "./MemoryGame.vue?vue&type=script&lang=js&"
export * from "./MemoryGame.vue?vue&type=script&lang=js&"
import style0 from "./MemoryGame.vue?vue&type=style&index=0&id=3bca0c72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca0c72",
  null
  
)

export default component.exports